import { render, staticRenderFns } from "./AmbassadorsTouchPointPopup.vue?vue&type=template&id=99789966&scoped=true"
import script from "./AmbassadorsTouchPointPopup.vue?vue&type=script&lang=js"
export * from "./AmbassadorsTouchPointPopup.vue?vue&type=script&lang=js"
import style0 from "./AmbassadorsTouchPointPopup.vue?vue&type=style&index=0&id=99789966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99789966",
  null
  
)

export default component.exports